import React from 'react';
import { Link } from '@noom/wax-component-library';
import { MentionSymbol } from '../constants';
export const Mention = (props) => {
    const { attributes, children, element } = props;
    const { value, mentionType } = element;
    return (React.createElement(Link, Object.assign({}, attributes, { contentEditable: false, "data-slate-value": value, "data-cy": `mention-${value === null || value === void 0 ? void 0 : value.replace(' ', '-')}` }),
        children,
        MentionSymbol[mentionType],
        value));
};
//# sourceMappingURL=Mention.js.map